import format from 'date-fns/format';
import React from 'react';
import PropTypes from 'prop-types';
import { Hint } from 'react-vis';

import common from 'constants/common';

const getPositive = (y) => {
  if (Number(y) < 0) {
    return 0;
  }
  return y;
};

const ChartHint = ({ hoveredPoint, type, ...rest }) => {
  let date;
  switch (type) {
    case 'Glucose':
      date = format(
        new Date(parseInt(hoveredPoint.actualTime)),
        common.dateFormats.dateAndTime,
      );
      break;
    default:
      date = format(
        new Date(parseInt(hoveredPoint.x)),
        common.dateFormats.dateAndTime,
      );
      break;
  }
  return (
    <Hint
      value={{
        ...hoveredPoint,
        y: getPositive(hoveredPoint?.y),
      }}
      {...rest}
    >
      <div className="chart-hint">
        <p>{date}</p>
        <p>
          <strong>{type}:</strong> {hoveredPoint.y}
        </p>
      </div>
    </Hint>
  );
};

ChartHint.propTypes = {
  type: PropTypes.string.isRequired,
  hoveredPoint: PropTypes.shape().isRequired,
};

export default ChartHint;
